/**
 * Enum for form submission states.
 * @readonly
 * @enum {string}
 */
export const FormSubmissionState = Object.freeze({
  Draft: 'Draft',
  Submitted: 'Submitted',
})
